export const values = ['Power Elite', 'Power', 'Power CDR', 'Synergy', 'Other']
